import * as React from 'react';
import { Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { MergePDF } from './components/MergePDF';
import { PDFFields } from './components/PDFFields';
import { Diagnostic } from './components/Diagnostic';

export const routes = <Layout>
    <Route exact path='/' component={Home} />
    <Route path='/generatepdf' component={MergePDF} />
    <Route path='/pdffields' component={PDFFields} />
    <Route path='/usagedetails' component={Diagnostic} />
</Layout>;



// WEBPACK FOOTER //
// ./ClientApp/routes.tsx